import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { NodeCreators } from '../utils';
import { JastBuildingVisitor } from './common';
import { OrderByVisitor } from './order-by';
import { WhereVisitor } from './where';
export var QueryVisitor = /*#__PURE__*/function (_JastBuildingVisitor) {
  _inherits(QueryVisitor, _JastBuildingVisitor);

  var _super = _createSuper(QueryVisitor);

  function QueryVisitor() {
    var _this;

    _classCallCheck(this, QueryVisitor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "whereVisitor", new WhereVisitor(_this.tokens));

    _defineProperty(_assertThisInitialized(_this), "orderByVisitor", new OrderByVisitor(_this.tokens));

    _defineProperty(_assertThisInitialized(_this), "visitJqlQuery", function (ctx) {
      var whereContext = ctx.jqlWhere();
      var orderByContext = ctx.jqlOrderBy();
      return NodeCreators.Query(whereContext && whereContext.accept(_this.whereVisitor), orderByContext && orderByContext.accept(_this.orderByVisitor));
    });

    return _this;
  }

  return QueryVisitor;
}(JastBuildingVisitor);